import {
  Container,
  Card,
  Text,
  VStack,
  HStack,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  FormControl,
  FormLabel,
  Radio,
  Stack,
  RadioGroup,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Wrap,
} from "@chakra-ui/react";
import { useEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import { useMemberShip } from "../../providers/MemberShipProvider";
import { Link } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";
import StatusChip from "../utils/StatusChip";
import { MEMBERSHIP_STATUSES } from "../utils/membership_statuses";
import { useAuth } from "../../providers/AuthProvider";

export default function MemberShipInstallments() {
  const { state } = useLocation();
  const { user } = useAuth();
  const navigate = useNavigate();

  const {
    installments,
    getInstallments,
    acceptStorePayment,
    updateMembershipStatus,
  } = useMemberShip();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isConfirmOpen,
    onOpen: onConfirmOpen,
    onClose: onConfirmClose,
  } = useDisclosure();

  const [term, setTerm] = useState(-1);
  const [pendingStatus, setPendingStatus] = useState("");
  const cancelRef = useRef();

  const formik = useFormik({
    initialValues: {
      payment_mode: "COD",
    },
    onSubmit: async (values) => {
      console.log(state);
      let submitFields = {
        id: state.id,
        term: term,
        payment_mode: values.payment_mode,
        date: moment().format("YYYY-MM-DD"),
      };
      onClose();
      console.log(submitFields);
      try {
        await acceptStorePayment(submitFields);
      } catch (error) {
        toast.error("Error Accepting Payment !");
      }
    },
  });

  useEffect(() => {
    getInstallments(state.id);
  }, [state]);

  return (
    <>
      <Container maxW="6xl" my="4">
        <VStack>
          <Card borderRadius="md" p="4" width={"100%"}>
            <VStack w="100%">
              <HStack w="100%" justifyContent="space-between">
                <Text fontWeight="bold" className="customfont" fontSize="2xl">
                  Membership Installments
                </Text>
              </HStack>

              <VStack width="100%" spacing={4} alignItems="start">
                <Text>Name : {state.name}</Text>
                <Text>Membership ID : {state.id_number}</Text>
                <Text>Phone : {state.phone}</Text>
                <Text>Address : {state.address}</Text>
                <Text>
                  Membership Status : <StatusChip status={state.status} />
                </Text>
                {installments &&
                state.status.toLowerCase() === "active" &&
                (state.status.toLowerCase() !== MEMBERSHIP_STATUSES.REDEEMED && user.type == "ADMIN" )? (
                  <Button
                    colorScheme="red"
                    onClick={() => {
                      setPendingStatus("cancelled");
                      onConfirmOpen();
                    }}
                  >
                    Cancel Membership
                  </Button>
                ) : (
                  <></>
                )}
                {installments &&
                state.status.toLowerCase() === "active" &&
                installments.length > 0 &&
                installments[installments.length - 1].accepted_by_store ? (
                  <Button
                    onClick={() => {
                      setPendingStatus("redeemed");
                      onConfirmOpen();
                    }}
                    colorScheme="yellow"
                    variant="solid"
                  >
                    REDEEM
                  </Button>
                ) : null}
              </VStack>
            </VStack>
          </Card>

          <Card width={"100%"}>
            <table>
              <thead>
                <tr>
                  <th py="4" fontSize="sm">
                    Term
                  </th>
                  <th py="4" fontSize="sm">
                    Amount
                  </th>
                  <th py="4" fontSize="sm">
                    User Paid
                  </th>
                  <th style={{ width: "160px" }} py="4" fontSize="sm">
                    Store Payment Status
                  </th>
                  <th style={{ width: "160px" }} py="4" fontSize="sm">
                    Payment Mode
                  </th>
                  <th style={{ width: "160px" }} py="4" fontSize="sm">
                    Payment Date
                  </th>
                  <th style={{ width: "160px" }} py="4" fontSize="sm">
                    Action
                  </th>
                </tr>
              </thead>

              <tbody>
                {installments.map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td py="4" fontSize="sm">
                        {i.term}
                      </td>
                      <td py="4" fontSize="sm">
                        {" "}
                        {i.amount}
                      </td>
                      <td py="4" fontSize="sm">
                        {" "}
                        {i.paid_by_user ? "Yes" : "No"}
                      </td>
                      <td py="4" fontSize="sm">
                        {" "}
                        {i.accepted_by_store ? "Yes" : "No"}
                      </td>
                      <td py="4" fontSize="sm">
                        {" "}
                        {i.payment_mode}
                      </td>
                      <td py="4" fontSize="sm">
                        {i.user_payment_date == null
                          ? ""
                          : moment(i.user_payment_date).format("DD-MM-YYYY")}
                      </td>
                      <td py="4" fontSize="sm">
                        <VStack>
                          {i.accepted_by_store ? (
                            <Button w="98%" colorScheme="whatsapp">
                              <Link
                                to="/users/memberships/installments/print"
                                state={{ membership: state, term: i }}
                              >
                                Print Receipt
                              </Link>
                            </Button>
                          ) : (
                            <>
                              {/* {(installments[i.term - 2].accepted_by_store ) ? */}
                              <Button
                                colorScheme="purple"
                                w="98%"
                                onClick={() => {
                                  setTerm(i.term);
                                  onOpen();
                                }}
                              >
                                Accept Payment
                              </Button>
                              {/* : <></> */}
                              {/* } */}
                            </>
                          )}
                        </VStack>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Card>

          {/* <SimpleGrid columns={[1, 1, 2, 4]} spacing='4'>

                    {installments.map((i, idx) => {
                        return (
                            <Card key={idx} bg={i.accepted_by_store ? 'green.100' : i.paid_by_user ? 'yellow.100' : 'gray.100'} borderRadius='md' p='4' width={'100%'}>
                                <VStack w='100%'>
                                    <VStack w='100%' justifyContent='start' alignItems='start'>
                                        <Text>Term : {i.term}</Text>
                                        <Text>Amount : {i.amount}</Text>
                                        <Text>Paid by User: {i.paid_by_user ? 'Yes' : 'No'}</Text>
                                        <Text>Confirmed By Store: {i.accepted_by_store ? 'Yes' : 'No'}</Text>
                                        <VStack alignItems='start'>
                                            {(i.paid_by_user && !i.accepted_by_store) &&
                                                <Button colorScheme="whatsapp">Accept Payment</Button>
                                            }
                                            {(!i.paid_by_user) &&
                                                <Button colorScheme="red">Mark Paid</Button>
                                            }
                                        </VStack>
                                    </VStack>
                                </VStack>
                            </Card>
                        )
                    })}
                </SimpleGrid> */}
        </VStack>
      </Container>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Accept Payment</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <form onSubmit={formik.handleSubmit}>
              <VStack alignItems="start" spacing="6">
                <FormControl>
                  <FormLabel>Payment Mode</FormLabel>
                  <RadioGroup
                    onChange={(e) => {
                      formik.setFieldValue("payment_mode", e);
                    }}
                    value={formik.values.payment_mode}
                  >
                    <Wrap direction="row">
                      <Radio
                        _selected={formik.values.payment_mode == "COD"}
                        value="COD"
                      >
                        COD
                      </Radio>
                      <Radio
                        _selected={formik.values.payment_mode == "Online"}
                        value="Online"
                      >
                        Online
                      </Radio>
                      <Radio
                        _selected={formik.values.payment_mode == "Cash"}
                        value="Cash"
                      >
                        Cash
                      </Radio>
                      <Radio
                        _selected={formik.values.payment_mode == "UPI"}
                        value="UPI"
                      >
                        UPI
                      </Radio>
                      <Radio
                        _selected={formik.values.payment_mode == "Cheque"}
                        value="Cheque"
                      >
                        Cheque
                      </Radio>
                      <Radio
                        _selected={formik.values.payment_mode == "Card"}
                        value="Card"
                      >
                        Card
                      </Radio>
                      <Radio
                        _selected={formik.values.payment_mode == "RTGS"}
                        value="RTGS"
                      >
                        RTGS
                      </Radio>
                    </Wrap>
                  </RadioGroup>
                </FormControl>
                <HStack>
                  <Button type="submit" colorScheme="whatsapp">
                    Accept
                  </Button>
                  <Button onClick={onClose} colorScheme="red">
                    Close
                  </Button>
                </HStack>
              </VStack>
            </form>
          </ModalBody>
        </ModalContent>
      </Modal>
      <AlertDialog
        isOpen={isConfirmOpen}
        leastDestructiveRef={cancelRef}
        onClose={onConfirmClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Action
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to <b>{pendingStatus}</b> this membership?
              This action cannot be undone.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onConfirmClose}>
                No
              </Button>
              <Button
                colorScheme={pendingStatus === "cancelled" ? "red" : "yellow"}
                onClick={async () => {
                  const result = await updateMembershipStatus(
                    state.id,
                    pendingStatus,
                  );
                  onConfirmClose();
                  if (result === "ok") {
                    navigate(-1);
                  }
                }}
                ml={3}
              >
                Yes, Confirm
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}
